import React, { useEffect, useState } from "react";
import { getCommonSettings } from "../../api/commonApi";

import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import CategoriesSection from "./components/CategoriesSection";
import PopularCoursesSection from "./components/PopularCoursesSection";
import CounterSection from "./components/CounterSection";
import WhyChooseUsSection from "./components/WhyChooseUsSection";
import TestimonialsSection from "../../components/TestimonialsSection";
import BlogSection from "./components/BlogSection";

function Home() {
  const [commonData, setCommonData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCommonSettings()
      .then((data) => {
        setCommonData(data || {});
      })
      .catch((err) => {
        console.error("API error:", err);
        setCommonData({});
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="container py-5 text-center">Loading...</div>;

  return (
    <main className="page-sections">
      <HeroSection data={commonData.hero} />
      <AboutSection data={commonData.about} />
      <CategoriesSection data={commonData.categories} />
      <PopularCoursesSection data={commonData.popularCourses} />
      <CounterSection data={commonData.counter} />
      <WhyChooseUsSection data={commonData.whyChooseUs} />
      <TestimonialsSection data={commonData.testimonials} />
      <BlogSection data={commonData.blogs} />
    </main>
  );
}

export default Home;
